import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject, Subscription } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { SettingsModalComponent } from 'src/app/shared/modals/settings-modal/settings-modal.component';
import { ConfigService } from 'src/app/shared/services/config/config.service';

type ProfileType = {
  givenName?: string,
  surname?: string,
  userPrincipalName?: string,
  id?: string
};

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  
  title = 'Tenant Manager'; 
  loggedInUser: string;
  
  constructor(private router: Router, private modalService: NgbModal,  private http: HttpClient) { }

  ngOnInit() {
   this.getProfile(); 
  }
  
  getProfile() {  
    this.http.get(ConfigService.settings.graphUrl)
    .subscribe((profile: ProfileType) => {
      this.loggedInUser = profile?.givenName + ' ' + profile?.surname;
    });
  }

  openSettingModal(){
  const modalRef = this.modalService.open(SettingsModalComponent);
  }  

}
